import { render, staticRenderFns } from "./pictureUpdate.vue?vue&type=template&id=2bea5830&"
import script from "./pictureUpdate.vue?vue&type=script&lang=js&"
export * from "./pictureUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports